export default {
	create_document: 'Dokument',
	create_menu_appointment: 'Termin',
	create_menu_dataset: 'Akte',
	create_menu_document: 'Dokument',
	create_menu_mail: 'Mail',
	create_menu_message: 'Nachricht',
	create_menu_note: 'Merkzettel',
	create_menu_phonecall: 'Anruf',
	create_menu_task: 'Aufgabe',
	menu_addon_not_available: 'Diese Erweiterung ist nicht mehr verfügbar',
	menu_addons: 'Erweiterungen',
	menu_all: 'Alle',
	menu_appointments: 'Kalender',
	menu_create: 'Neu',
	menu_datasets: 'Akten',
	menu_datasets_box_label: 'Instanzen',
	menu_date: 'Datum',
	menu_documents: 'Dokumente',
	menu_documents_box_label: 'Ablagen',
	menu_favorites: 'Shortcuts',
	menu_filter: 'Filter',
	menu_folder_explorer: 'Organisation',
	menu_folder_explorer_actions: 'Aktionen',
	menu_folder_explorer_add_folder: 'Mappe anlegen',
	menu_folder_explorer_add_list_container: 'Listenordner anlegen',
	menu_folder_explorer_back_to_organization: 'Zurück zur Organisation',
	menu_folder_explorer_close: 'Schließen',
	menu_folder_explorer_confirm_delete_message: 'Möchten Sie dieses Element wirklich löschen?',
	menu_folder_explorer_confirm_delete_title: 'Element löschen',
	menu_folder_explorer_create_and_link_ido: 'Akte aus Mappe erstellen',
	menu_folder_explorer_empty_folders: 'Keine Mappen vorhanden',
	menu_folder_explorer_empty_ido_favorites: 'Keine Akten-Favoriten vorhanden',
	menu_folder_explorer_empty_lists: 'Keine Listen vorhanden',
	menu_folder_explorer_filter_placeholder: 'Filtern',
	menu_folder_explorer_folders_tab: 'Mappen',
	menu_folder_explorer_ido_favorites_searching: 'Akten werden gesucht…',
	menu_folder_explorer_ido_favorites_tab: 'Favoriten',
	menu_folder_explorer_legacy_badge: 'Legacy',
	menu_folder_explorer_lists_tab: 'Listen',
	menu_folder_explorer_load_error: 'Der Ordner-Explorer konnte nicht geladen werden.',
	menu_folder_explorer_loading: 'Baum wird geladen…',
	menu_folder_explorer_notebook_list_empty: 'Diese Mappe enthält keine Einträge',
	menu_folder_explorer_notebook_list_title: 'Mappeninhalt',
	menu_folder_explorer_open: 'Öffnen',
	menu_folder_explorer_open_as_kanban_board: 'Als Kanban Board öffnen',
	menu_folder_explorer_open_not_supported: 'Dieses Legacy-Ziel ist in der App noch nicht abgebildet',
	menu_folder_explorer_remove: 'Löschen',
	menu_folder_explorer_rename: 'Umbenennen',
	menu_folder_explorer_rename_prompt: 'Name',
	menu_folder_explorer_search_empty: 'Keine Treffer gefunden',
	menu_folder_explorer_search_placeholder: 'Suchen',
	menu_folder_explorer_share: 'Teilen',
	menu_folder_explorer_unshare: 'Entziehen',
	menu_global_filter: 'Globaler Filter',
	menu_ido_favorites_context_menu_create_ido_linked_task: 'Aufgabe anlegen',
	menu_ido_favorites_remove_from_favorites: 'Aus den Favoriten entfernen',
	menu_ido_search_empty_title: 'Über alle Akten suchen',
	menu_ido_search_no_results: 'Keine Treffer',
	menu_idos: 'Akten',
	menu_idos_all: 'Alle Akten anzeigen',
	menu_idos_as_list: 'Akten Instanzen als Liste anzeigen',
	menu_idos_box_label: 'Akten Instanzen',
	menu_inbox: 'Startseite',
	menu_kanban: 'Kanban Board',
	menu_kanban_shared_query_not_found: 'Diese Liste konnte nicht als Kanban Board geöffnet werden.',
	menu_lists: 'Listen',
	menu_logout: 'Abmelden',
	menu_logout_dialog_message: 'Möchten Sie sich wirklich abmelden?',
	menu_logout_dialog_title: 'Sitzung beenden',
	menu_mails: 'Mails',
	menu_mails_box_label: 'Postfächer',
	menu_messages: 'Nachrichten',
	menu_mine: 'Meine',
	menu_notes: 'Merkzettel',
	menu_open: 'Offen',
	menu_phonecalls: 'Anrufe',
	menu_phonecalls_box_label: 'Anruflisten',
	menu_search_clear: 'Suche zurücksetzen',
	menu_search_no_results: 'Keine Treffer',
	menu_search_placeholder: 'Menü durchsuchen…',
	menu_settings: 'Einstellungen',
	menu_sidebar_search_placeholder: 'Suche...',
	menu_sidebar_tab_menu: 'Menü',
	menu_sidebar_tab_organization: 'Organisation',
	menu_sidebar_tab_search: 'Suche',
	menu_sidebar_tab_users: 'Benutzer',
	menu_tasks: 'Aufgaben',
	menu_timer: 'Timer',
	menu_today: 'Heute',
	menu_trash: 'Papierkorb',
	menu_user_online: 'Benutzer',
	menu_user_online_no_users_offline: 'Kein Benutzer abgemeldet',
	menu_user_online_no_users_online: 'Kein Benutzer angemeldet',
	menu_user_online_offline_users: 'Abgemeldet',
	menu_user_online_offline_users_short: 'offline',
	menu_user_online_online_users: 'Angemeldet',
	menu_user_online_online_users_short: 'online',
};
